import SorRepo from 'Admin/Configuration/repo/sor_repo'
import CreditRepo from 'Admin/CreditManagement/repo/credit_repo'
import MonthCloseRepo from 'Admin/MonthClose/repo/monthCloseRepo'
import AdminRepo from 'ts/modules/admin/repo/AdminRepo'
import BudgetsRepoNew from 'ts/modules/budgets/repo/BudgetsRepo'
import SummaryRepo from 'ts/modules/summary/repo/SummaryRepo'
import { RepoParams } from 'ts/types'
import VendorRepo from 'VendorManagement/Pricing/repo/vendor_repo'
import ActualsRepo from './Actuals/repo/ActualsRepo'
import UserRepo from './Admin/Users/repo/user_repo'
import AuthRepo from './Authentication/repo/auth_repo'
import BudgetsRepo from './Budgets/repo/budgets_repo'
import CommonRepo from './common/repo/common_repo'
import HttpClient from './httpClient'
import BIRepo from './Reporting/BusinessIntelligence/repo/bi_repo'
import TimePeriodsRepo from './Reporting/PeriodCards/repo/time_periods_repo'
import SpacesRepo from './Spaces/repo/space_repo'
import QuickSuiteChatRepo from './ts/components/quick-suite-chat/repo/QuickSuiteChatRepo'
import MapManagementRepo from './ts/modules/admin/sections/map-management/repo/map_repo'
import AIGovernanceRepo from './ts/modules/ai-governance/repo/AIGovernanceRepo'
import SavingsManagementRepo from './ts/modules/savings-management/repo/SavingsManagementRepo'

class RepoFactory {
  private httpClient: HttpClient
  private GRAPHQL_URL: string
  private GRAPHQL_API_KEY: string
  private ID_TOKEN: string

  constructor({ httpClient, GRAPHQL_URL, GRAPHQL_API_KEY, ID_TOKEN }: RepoParams) {
    this.httpClient = httpClient
    this.GRAPHQL_URL = GRAPHQL_URL
    this.GRAPHQL_API_KEY = GRAPHQL_API_KEY || ''
    this.ID_TOKEN = ID_TOKEN || ''
  }

  private getRepoConfig(): RepoParams {
    return {
      GRAPHQL_URL: this.GRAPHQL_URL,
      ID_TOKEN: this.ID_TOKEN,
      httpClient: this.httpClient
    }
  }

  commonRepo = (): CommonRepo => {
    return new CommonRepo(this.getRepoConfig())
  }

  authRepo = (): AuthRepo => {
    return new AuthRepo({ ...this.getRepoConfig(), GRAPHQL_API_KEY: this.GRAPHQL_API_KEY })
  }

  timePeriodsRepo = (): TimePeriodsRepo => {
    return new TimePeriodsRepo(this.getRepoConfig())
  }

  userRepo = (): UserRepo => {
    return new UserRepo(this.getRepoConfig())
  }

  actualsRepo = (): ActualsRepo => {
    return new ActualsRepo(this.getRepoConfig())
  }

  summaryRepo = (): SummaryRepo => {
    return new SummaryRepo(this.getRepoConfig())
  }

  budgetsRepo = (): BudgetsRepo => {
    return new BudgetsRepo(this.getRepoConfig())
  }

  budgetsRepoNew = (): BudgetsRepoNew => {
    return new BudgetsRepoNew(this.getRepoConfig())
  }

  spacesRepo = (): SpacesRepo => {
    return new SpacesRepo(this.getRepoConfig())
  }

  biRepo = (): BIRepo => {
    return new BIRepo(this.getRepoConfig())
  }

  quickSuiteChatRepo = (): QuickSuiteChatRepo => {
    return new QuickSuiteChatRepo(this.getRepoConfig())
  }

  monthCloseRepo = (): MonthCloseRepo => {
    return new MonthCloseRepo(this.getRepoConfig())
  }

  sorRepo = (): SorRepo => {
    return new SorRepo(this.getRepoConfig())
  }

  vendorRepo = (): VendorRepo => {
    return new VendorRepo(this.getRepoConfig())
  }

  creditRepo = (): CreditRepo => {
    return new CreditRepo(this.getRepoConfig())
  }

  adminRepo = (): AdminRepo => {
    return new AdminRepo(this.getRepoConfig())
  }

  savingsManagementRepo = (): SavingsManagementRepo => {
    return new SavingsManagementRepo(this.getRepoConfig())
  }

  mapManagementRepo = (): MapManagementRepo => {
    return new MapManagementRepo(this.getRepoConfig())
  }

  aiGovernanceRepo = (): AIGovernanceRepo => {
    return new AIGovernanceRepo(this.getRepoConfig())
  }
}

export default RepoFactory
